// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"83":"4ce20330","244":"9ddffb82","426":"4ab2793c","453":"d67139e5","673":"867fed0f","694":"b62857db","723":"d6d71a04","732":"2a6b0a0c","765":"10b2cafc"}[chunkId] + ".chunk.js";
};